var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 294,
    viewBox: "0 0 150 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.41 216.6C149.41 258.6 114.31 294 72.31 294C41.4 294 13.2 275.1 0 243.9L14.7 237.6C25.5 263.4 47.4 277.8 72.31 277.8C80.3658 277.868 88.3545 276.331 95.8104 273.28C103.266 270.228 110.04 265.723 115.736 260.026C121.433 254.33 125.938 247.556 128.99 240.1C132.041 232.645 133.578 224.656 133.51 216.6C133.51 182.1 106.51 155.1 72.31 155.1L70.05 145.19C71.87 144.97 72.31 144.9 72.31 144.9C106.51 138.9 133.51 111.9 133.51 77.3999C133.578 69.3441 132.041 61.3554 128.99 53.8995C125.938 46.4437 121.433 39.6701 115.736 33.9735C110.04 28.277 103.266 23.7716 95.8104 20.7201C88.3545 17.6686 80.3658 16.132 72.31 16.2C47.4 16.2 25.5 30.5999 14.7 56.3999L0 50.1C13.2 18.9 41.4 0 72.31 0C114.31 0 149.41 35.3999 149.41 77.3999C149.41 110.1 128.41 138.6 107.11 147C128.41 155.4 149.41 183.9 149.41 216.6Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3);
export default __webpack_public_path__ + "static/media/NUMBER_3.94919ceb2928b2444975ad7b2c02ecf0.svg";
export { ForwardRef as ReactComponent };